/* src/app/core/components/home/home.component.scss */
ion-menu {
  --width: var(--side-menu-width, 304px);
}
/*# sourceMappingURL=home.component.css.map */
